import { Component, OnInit } from '@angular/core';
import { Functions } from '@hub/common/Functions';
import { eModules, eSystemModule, eUserPermissionLevel } from '@hub/generated/enums';
import { MenuItem } from '@hub/models/MenuItem';
import { MenuService } from './service/menu.service';
import { CurrentUserService } from '@hub/services/CurrentUserService';
import { take } from 'rxjs/operators';
import { UserRoleSystemModuleDto } from '@hub/generated/models';

const AllMenuItems: MenuItem[] = [
	new MenuItem('Deals', 'pi pi-copy', true, 20, true, ['/main'], null,
		[eSystemModule.HUBDeal_Deal, eSystemModule.HUBTv10Percent_Tv10Percent, eSystemModule.HUBTvPackages_TvPackages] ),
	new MenuItem('User', 'pi pi-cog', true, 50, true, ['/' + Functions.getEnumName(eModules, eModules.Users, false).toLowerCase()], null,
		[eSystemModule.HUBContacts_Users])
];

@Component({
	selector: 'menu',
	templateUrl: 'menu.component.html'
})
export class MenuComponent implements OnInit {
	constructor(
		protected menuService: MenuService,
		private currentUser: CurrentUserService
	) {
	}

	menuItems: MenuItem[];
	userRoleSystemModules: UserRoleSystemModuleDto[];

	ngOnInit(): void {
		this.currentUser.UserSystemModules
			.pipe(take(1)).subscribe(modules => {
				this.userRoleSystemModules = modules;
				this.setMenuItems();
		})
	}

	setMenuItems() {
		this.menuItems = AllMenuItems.filter(item => !item.Roles ||
			this.userRoleSystemModules.some(c => item.Modules && item.Modules.includes(c.SystemModuleId)
					&& c.UserPermissionLevelFlag >= eUserPermissionLevel.Read)
		);
	}
}
